module.exports = __webpack_public_path__ + "img/books.ba56b14e.png";